import { DialogButton } from '../../enums/dialog-button.enum';

/**
 * A class to store the results from a dialog
 */
export class DialogResult<T> {
  /**
   * @param button - The clicked button
   * @param data - The data returned by the dialog
   * @param data2 - Additional data returned by the diaoig
   * @param data3 - Additional data returned by the dialog
   */
  constructor(
    public button: DialogButton,
    public data?: T,
    public data2?: any,
    public data3?: any
  ) {}
}
